import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Form,
  Modal,
  InputGroup,
  Jumbotron,
  Collapse,
} from "react-bootstrap";
import Datetime from "react-datetime";
import Card from "components/Card/Card.jsx";
import Select from "react-select";

import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import {
  getCountry,
  getb2b,
  AddLead,
  getCity,
  getOrganizationDataWithoutPagination,
} from "../../../Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import SweetAlert from "react-bootstrap-sweetalert";
import { Map, Marker, GoogleApiWrapper } from "google-maps-react";
import Autocomplete from "react-google-autocomplete";
import Collapsible from "react-collapsible";
import { getApiErrorMessage } from "utils/getApiErrorMessage";

class addlead extends Component {
  constructor(props) {
    super(props);
    this.state = {
      b2cDetails: [],
      processing: true,
      country_data: [],
      organizationdetail: [],
      name: "",
      nameError: null,
      email: "",
      emailError: null,
      mobileno: "",
      mobilenoError: null,
      ccode: "+94",
      organizationError: null,
      organization: "0",
      phone: null,
      pcode: "+94",
      phoneError: null,
      leadowner: "",
      leadownerError: null,
      leadstatus: "3",
      leadstatusError: null,
      address_line_1: "",
      address_line_1Error: null,
      address_line_2: "",
      address_line_2Error: null,
      city: "",
      cityError: null,
      country: "0",
      countryError: null,
      state: "",
      stateError: null,
      postalcode: "",
      postalcodeError: null,
      comment: "",
      commentError: null,
      source: "1",
      _notificationSystem: null,
      cardHidden: true,
      showModal: false,
      gender: "",
      age: "",
      NIC_passportnum: "",
      bodytem: "",
      occupation: "",
      MOHarea: "",
      partial: false,
      partial_contact: "",
      pccode: "+94",
      partial_contactError: null,
      partial_email: "",
      partial_emailError: null,
      partial_name: "",
      emergency_contact_name: "",
      emergency_contact_num: "",
      eccode: "+94",
      emergency_contact_numError: null,
      userrole: "",
      dob: null,
      customaddress: "",
      customaddressError: null,
      symptoms: [],
      is_b2b: "",
      symptomsdata: [
        { id: 1, label: "Fever", checked: false },
        { id: 2, label: "Cough", checked: false },
        { id: 3, label: "Sore Throat", checked: false },
        { id: 4, label: "Difficulty in Breathing", checked: false },
      ],
      Epidemiological_Evidence: [],
      Epidemiological_Evidence_data: [
        {
          id: 11,
          label: "Contact history with diagnosed nCoV-19",
          checked: false,
        },
        {
          id: 12,
          label: "Contact history with suspect nCoV-19",
          checked: false,
        },
        {
          id: 13,
          label: "Patient from a lockdown/isolated area",
          checked: false,
        },
      ],
      city_info: [],
      mobileerror: "",
      alert: null,
      latitude: "",
      longitude: "",
      addresslist: [
        {
          srno: 1,
          address_line_1: "",
          address_line_2: "",
          city: "0",
          state: "",
          country: "1",
          postalcode: "",
          country_error: "",
          city_error: "",
          addresstypeError: "",
          customaddressError: "",
          addresstype: "",
          customaddress: "",
          latitude: "",
          longitude: "",
          selectedPlace: { name: "" },
        },
      ],
      errormessages: [],
      country_code: "LK",
      selectedPlace: { name: "" },
      lat: null,
      lng: null,
      bounds_data: null,
      formattedAddress: "",
      coordinates: "",
      store_id: "",
      showDiagnostic: true,
      showAddress: true,
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    // this.handleSelectChange = this.handleSelectChange.bind(this)
    this.emailInput = React.createRef();
    this.handleEpidemiological_Evidence =
      this.handleEpidemiological_Evidence.bind(this);
    this.handlesymptoms = this.handlesymptoms.bind(this);
    this.checkpatient = this.checkpatient.bind(this);
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  handleDateChange = (date) => {
    this.setState({
      dob: date,
    });
  };
  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Customer</b> - Added Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
    setTimeout(() => {
      //this.props.history.push('/admin/lead');
    }, 3000);
  }
  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  async componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ userrole: token.role, store_id: token.store_id });
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700,
    );

    getCountry(obj).then((res) => {
      var data = res.data;
      this.setState({
        country_data: data,
      });
    });
    let compelte = 1;
    let pg_no = 1;
    while (compelte == 1) {
      await getb2b(obj, pg_no).then((response) => {
        // console.log(response);
        var customerdata = response.data;
        if (customerdata.data.length == 0) {
          compelte = 0;
        } else {
          var array1 = this.state.organizationdetail;
          var array2 = array1.concat(customerdata.data);

          this.setState({
            organizationdetail: array2,
          });
        }
      });
      pg_no++;
    }
    getCity(obj, 1).then((res) => {
      this.setState({ city_info: res.data });
    });

    getOrganizationDataWithoutPagination(obj).then((res) => {
      let Org = [];
      const companyData = res.data;
      const organizationdetail = companyData.map((data) => {
        return {
          value: data.id,
          label: data.company_name,
        };
      });
      Org = [
        { value: "", label: "Select organization" },
        ...organizationdetail,
      ];
      this.setState({ organizationdetail: Org });
    });
  }
  handleInputChange = (e, index, country) => {
    const { name, value } = e.target;
    // const {value } = e.target.type === 'select' ? e.target.selected : e.target.value;
    const list = [...this.state.addresslist];
    list[index][name] = value;
    // console.log(list[index]['country'])

    if (name === "city" && value !== "0") {
      list[index]["city_error"] = null;
    }
    if (country) {
      const countryCode = this.state.country_data.find(
        (item) => item.id == value,
      ).country_code;
      this.setState({ country_code: countryCode });
    }

    if (list[index]["country"] != "0") {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      var country_id = list[index]["country"];
      getCity(obj, country_id).then((res) => {
        this.setState({ city_info: res.data });
      });
    } else if (list[index]["country"] == "0") {
      this.setState({ city_info: [] });
    }
    this.setState({ addresslist: list });
  };

  handleInputLocationChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...this.state.addresslist];
    // list[index][name] = value;

    if (value) {
      const coordinatesArray = value.split(",");

      if (coordinatesArray.length === 2) {
        const lat = coordinatesArray[0];
        const lng = coordinatesArray[1];

        // Update state with new latitude and longitude
        this.setState((prevState) => {
          const updatedAddressList = [...prevState.addresslist];
          updatedAddressList[index] = {
            ...updatedAddressList[index],
            latitude: lat,
            longitude: lng,
          };
          return { addresslist: updatedAddressList };
        });
      }
    } else {
      this.setState((prevState) => {
        const updatedAddressList = [...prevState.addresslist];
        updatedAddressList[index] = {
          ...updatedAddressList[index],
          latitude: "",
          longitude: "",
        };
        return { addresslist: updatedAddressList };
      });
      console.log("Geometry location not available for this place");
    }
  };

  handlesymptoms(e, i) {
    var checked = e.target.checked;
    var list = [...this.state.symptomsdata];
    list[i]["checked"] = checked;
    this.setState({ symptoms: list });
  }
  checkpatient(e) {
    var checked = e.target.checked;
    console.log(checked, "checked");
    if (checked == false) {
      this.setState({
        partial_contact: "",
        partial_name: "",
        partial_email: "",
        partial_contactError: null,
        partial_emailError: null,
      });
    }
    this.setState({ partial: checked });
  }
  handleEpidemiological_Evidence(e, i) {
    var checked = e.target.checked;
    var list = [...this.state.Epidemiological_Evidence_data];
    list[i]["checked"] = checked;
    this.setState({ Epidemiological_Evidence: list });
    console.log(this.state.Epidemiological_Evidence);
  }
  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };
  onSubmit = () => {
    this.setState({ errormessages: [] });
    let error = false;

    if (this.state.name.length == 0) {
      error = true;
      this.setState({
        nameError: <small className="text-danger">Name is required.</small>,
      });
    } else {
      this.setState({ nameError: null });
    }

    if (this.state.leadstatus == "0") {
      error = true;
      this.setState({
        leadstatusError: (
          <small className="text-danger">Lead Status is required.</small>
        ),
      });
    } else {
      this.setState({ leadstatusError: null });
    }

    // Mobile no validation
    if (
      (this.state.mobileno.length < 9 && this.state.organization == "0") ||
      (this.state.mobileno.length > 11 && this.state.organization == "0")
    ) {
      error = true;
      this.setState({
        mobilenoError: (
          <small className="text-danger">
            Please enter mobile nunber from 9 to 11 digit.
          </small>
        ),
      });
    } else if (
      this.state.organization != "0" &&
      this.state.mobileno.length > 0
    ) {
      error = false;
      if (this.state.mobileno.length < 9 || this.state.mobileno.length > 11) {
        error = true;
        this.setState({
          mobilenoError: (
            <small className="text-danger">
              Please enter mobile nunber from 9 to 11 digit.
            </small>
          ),
        });
      }
    } else {
      this.setState({ mobilenoError: null });
    }
    if (this.state.phone == null) {
      this.setState({ phoneError: null });
    } else if (this.state.phone != null) {
      if (this.state.phone.length < 9 || this.state.phone.length > 11) {
        error = true;
        this.setState({
          phoneError: (
            <small className="text-danger">
              Please enter phone number from 9 to 11 digit.
            </small>
          ),
        });
      }
    } else {
      this.setState({ phoneError: null });
    }
    if (this.state.email.length == 0) {
      this.setState({ emailError: null });
    } else if (this.state.email.length > 0) {
      var emailRex = new RegExp(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      );
      if (emailRex.test(this.state.email) === false) {
        error = true;
        this.setState({
          emailError: (
            <small className="text-danger">
              Email format should be abc@doe.com.
            </small>
          ),
        });
      }
    } else {
      this.setState({ emailError: null });
    }
    if (this.state.partial_contact.length == 0) {
      this.setState({ partial_contactError: null });
    } else if (this.state.partial_contact.length > 0) {
      if (
        this.state.partial_contact.length < 9 ||
        this.state.partial_contact.length > 11
      ) {
        error = true;
        this.setState({
          partial_contactError: (
            <small className="text-danger">
              Please enter pantient phone no from 9 to 11 digit.
            </small>
          ),
        });
      }
    } else {
      this.setState({ partial_contactError: null });
    }
    if (this.state.emergency_contact_num.length == 0) {
      this.setState({ emergency_contact_numError: null });
    } else if (this.state.emergency_contact_num.length > 0) {
      if (
        this.state.emergency_contact_num.length < 9 ||
        this.state.emergency_contact_num.length > 11
      ) {
        error = true;
        this.setState({
          emergency_contact_numError: (
            <small className="text-danger">
              Please enter emergency contact person number from 9 to 11 digit.
            </small>
          ),
        });
      }
    } else {
      this.setState({ emergency_contact_numError: null });
    }

    if (this.state.partial_email.length == 0) {
      this.setState({ partial_emailError: null });
    } else if (this.state.partial_email.length > 0) {
      var emailRex = new RegExp(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      );
      if (emailRex.test(this.state.partial_email) === false) {
        error = true;
        this.setState({
          partial_emailError: (
            <small className="text-danger">
              Pantient Email format should be abc@doe.com.
            </small>
          ),
        });
      }
    } else {
      this.setState({ partial_emailError: null });
    }
    const list = [...this.state.addresslist];
    if (this.state.addresslist.length != 0) {
      this.state.addresslist.map((x, i) => {
        /*if (x.country == 0) {
          const list = [...this.state.addresslist];
          list[i]["country_error"] = (
            <small className="text-danger"> Country is required. </small>
          );
          error = true;
        }

        if (x.city == 0) {
          const list = [...this.state.addresslist];
          list[i]["city_error"] = (
            <small className="text-danger"> City is required. </small>
          );
          error = true;
        }

        if (x.addresstype == "") {
          const list = [...this.state.addresslist];
          list[i]["addresstypeError"] = (
            <small className="text-danger">Addresstype is required</small>
          );
          error = true;
        }*/

        // if (x.address_line_1 == 0) {
        //   error = true;
        //   this.setState({
        //     address_line_1Error: (
        //       <small className="text-danger">Address is required.</small>
        //     ),
        //   });
        // } else {
        //   this.setState({ address_line_1Error: null });
        // }
        // if (x.city == 0) {
        //   const list = [...this.state.addresslist];
        //   list[i]["city_error"] = (
        //     <small className="text-danger"> District is required. </small>
        //   );
        //   error = true;
        // }
        if (x.addresstype == "Custom") {
          if (x.customaddress == "") {
            const list = [...this.state.addresslist];
            list[i]["customaddressError"] = (
              <small className="text-danger">Custom address is required</small>
            );
            error = true;
          }
        }
      });

      if (error) {
        this.emailInput.current.focus();
        this.setState({ addresslist: list });
      }
    }

    const data = this.state.addresslist.map((item) => {
      if (
        (item.address_line_1 !== "" || item.address_line_2 !== "") &&
        item.city == 0
      ) {
        error = true;
        return {
          ...item,
          city_error: (
            <small className="text-danger"> District is required. </small>
          ),
        };
      } else {
        return {
          ...item,
          city_error: null,
        };
      }
    });
    this.setState({
      addresslist: data,
    });

    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      const { lat, lng } = this.state;

      let addressform = [];
      this.state.addresslist.map((x, i) => {
        console.log(x.addresstype, "ad type ");
        let addressdata = "";
        // const bindAddress = `${x.address_line_2},${""}${x.address_line_1}`;

        if (x.addresstype == "Custom") {
          addressdata = x.customaddress;
        } else {
          addressdata = x.addresstype;
        }

        addressform.push({
          address_line1: x.address_line_1,
          address_line2: x.address_line_2,
          city:
            this.state.store_id === 2
              ? 4
              : x.city === "" || x.city === "0"
                ? "1"
                : x.city,
          state: x.state,
          country_id: x.country,
          postal_code: x.postalcode,
          address_type: addressdata,
          customaddress: x.customaddress,
          latitude: x.latitude,
          longitude: x.longitude,
        });
      });

      let symptoms_details = [];
      let Epidemiological_Evidence_details = [];

      if (
        this.state.userrole == 6 ||
        this.state.userrole == 1 ||
        this.state.userrole == 2
      ) {
        this.state.symptoms.map((s) => {
          if (s.checked == true) {
            symptoms_details.push(s.label);
          }
        });
        this.state.Epidemiological_Evidence.map((e) => {
          if (e.checked == true) {
            Epidemiological_Evidence_details.push(e.label);
          }
        });
      }
      var today = null;
      if (this.state.dob != null) {
        const date = new Date(this.state.dob);
        var dd = ("0" + date.getDate()).slice(-2);
        var mm = ("0" + (date.getMonth() + 1)).slice(-2);
        var yyyy = date.getFullYear();
        today = yyyy + "-" + mm + "-" + dd;
      }

      var mobile = "";
      var phone = null;
      var emergency_contact_num = "";
      var partial_contact = "";
      if (this.state.mobileno.length != 0) {
        mobile = this.state.ccode + this.state.mobileno;
      }
      if (this.state.phone != null) {
        phone = this.state.pcode + this.state.phone;
      }
      if (this.state.emergency_contact_num.length != 0) {
        emergency_contact_num =
          this.state.eccode + this.state.emergency_contact_num;
      }
      if (this.state.partial_contact.length != 0) {
        partial_contact = this.state.pccode + this.state.partial_contact;
      }
      var channel = "admin";

      var is_b2buser = "";
      if (this.state.is_b2b == "1") {
        is_b2buser = "1";
      } else if (this.state.is_b2b == "2") {
        is_b2buser = "0";
      }

      this.setState({ processing: false }, () => {
        AddLead(
          this.state.name,
          this.state.email,
          mobile,
          phone,
          this.state.leadstatus,
          addressform,
          this.state.comment,
          this.state.source,
          this.state.organization.value ? this.state.organization.value : "",
          channel,
          this.state.gender,
          today,
          this.state.NIC_passportnum,
          this.state.bodytem,
          this.state.occupation,
          this.state.MOHarea,
          this.state.partial_name,
          partial_contact,
          this.state.partial_email,
          this.state.emergency_contact_name,
          emergency_contact_num,
          symptoms_details,
          Epidemiological_Evidence_details,
          is_b2buser,
          obj,
          this.state.country_code,
          this.state.store_id === null ? "" : this.state.store_id,
        )
          .then((res) => {
            //  console.log(res.data.data,"lead data")
            if (res.data.success === false) {
              this.setState({ processing: true });
              if (res.data.data.length != 0) {
                var ermessage = [];
                for (var key of Object.keys(res.data.data)) {
                  var data = res.data.data[key];
                  ermessage.push(data);
                }
                this.setState({ errormessages: ermessage });
                var msg = res.data.data;
                this.emailInput.current.focus();
                this.setState({
                  mobilenoError: (
                    <small className="text-danger">{msg.mobile_no}</small>
                  ),
                });
              } else {
                this.handleClick("bl");
              }
            } else if (res.data.success === true) {
              this.setState({ processing: true });
              if (
                this.state.NIC_passportnum != "" ||
                this.state.bodytem != "" ||
                this.state.occupation != "" ||
                this.state.MOHarea != "" ||
                this.state.partial_contact != "" ||
                this.state.partial_email != "" ||
                this.state.partial_name != "" ||
                this.state.emergency_contact_name != "" ||
                this.state.emergency_contact_num != "" ||
                this.state.symptoms.length > 0 ||
                this.state.Epidemiological_Evidence.length > 0
              ) {
                setTimeout(() => {
                  this.props.history.push(
                    "/admin/lab-add-order/" + res.data.data.id,
                  );
                }, 3000);
              } else {
                setTimeout(() => {
                  this.props.history.push(
                    "/admin/add-order/" + res.data.data.id,
                  );
                }, 3000);
              }
              this.handleSuccess("bl");
              this.setState({
                name: "",
                email: "",
                mobileno: "",
                organization: "0",
                phone: null,
                leadowner: "",
                leadstatus: "3",
                gender: "",
                age: "",
                NIC_passportnum: "",
                bodytem: "",
                occupation: "",
                MOHarea: "",
                partial_contact: "",
                partial_email: "",
                partial_name: "",
                emergency_contact_name: "",
                emergency_contact_num: "",
                symptoms: [],
                Epidemiological_Evidence: [],
                // address_line_1 : '',
                // address_line_2 : '',
                // city : '',
                // country : '0',
                // state : '',
                // postalcode : '',
                addresslist: [
                  {
                    srno: 1,
                    address_line_1: "",
                    address_line_2: "",
                    city: "",
                    state: "",
                    country: 0,
                    postalcode: "",
                    latitude: "",
                    longitude: "",
                  },
                ],
                comment: "",
                source: "1",
              });
            }
          })
          .catch((error) => {
            console.log(error, "== error");
            this.handleNetworkError("bl", error);
          });
      });
    }
  };

  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {/* <b>Network Error</b>. */}
          <b>{getApiErrorMessage(error)}</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  serial = 2;
  getSerial() {
    return this.serial++;
  }

  showaddressform() {
    this.setState({ showModal: true });
  }
  handleRemoveClick = (index) => {
    const list = [...this.state.addresslist];
    list.splice(index, 1);
    this.setState({ addresslist: list });
    const list1 = list;

    let count_x = 1;
    list1.map((medi, ind) => {
      list1[ind]["srno"] = count_x;
      count_x++;
    });
    this.serial = count_x;
  };
  handleAddClick = () => {
    this.setState({
      addresslist: [
        ...this.state.addresslist,
        {
          srno: this.getSerial(),
          address_line_1: "",
          address_line_2: "",
          city: "",
          state: "",
          country: 0,
          postalcode: "",
          country_error: "",
          city_error: "",
          addresstype: "",
          addresstypeError: "",
          customaddress: "",
          customaddressError: "",
          latitude: null,
          longitude: null,
          selectedPlace: { name: "" },
        },
      ],
    });
  };
  onParentOrganizationChangeb2c = (value) => {
    this.setState({
      organization: value,
    });
  };

  handlePlaceSelected = (place, i) => {
    if (place.geometry && place.geometry.location) {
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      const newAddressList = [...this.state.addresslist];
      newAddressList[i] = {
        ...newAddressList[i],
        latitude: lat,
        longitude: lng,
        selectedPlace: { name: place.name },
        address_line_1: place.formatted_address,
      };

      this.setState({
        addresslist: newAddressList,
        lat,
        lng,
      });

      if (place.formatted_address) {
        this.setState({ address_line_1Error: null });
      }
    } else {
      console.log("Geometry location not available for this place");
    }
  };

  render() {
    const country = this.state.country_data;
    // console.log(cou)
    const organizationdetail = this.state.organizationdetail;
    const mobileerror = this.state.mobileerror;
    const errormessages = this.state.errormessages;

    // const re = /^[0-9\b]+$/;
    return (
      <div className="main-content addlead-page">
        <input
          style={{ width: "0px", height: "0px", border: "none" }}
          type="text"
          ref={this.emailInput}
        />
        <Grid fluid>
          {this.state.alert}

          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col md={12}>
              <Card
                content={
                  <form>
                    {errormessages.length != 0 && (
                      <div className=" alert alert-danger">
                        {errormessages.map((data) => (
                          <React.Fragment>
                            <li>{data}</li>
                          </React.Fragment>
                        ))}
                      </div>
                    )}
                    {this.state.userrole == 6 || this.state.userrole == 11 || 
                    this.state.userrole == 1 ||
                    this.state.userrole == 2 ||
                    this.state.userrole == 18 ? (
                      <h4
                        style={{
                          "text-align": " left",
                          "font-weight": "bold",
                        }}
                      >
                        Subscriber Details
                      </h4>
                    ) : (
                      ""
                    )}
                    <div
                      style={{
                        marginLeft: "10px",
                        marginRight: "10px",
                      }}
                    >
                      <Row>
                        <Col md={6} xs={12} sm={6}>
                          {this.state.userrole == 6 ||this.state.userrole == 11 || 
                          this.state.userrole == 1 ||
                          this.state.userrole == 2 ||
                          this.state.userrole == 18 ? (
                            <>
                              <FormGroup>
                                <ControlLabel>Name</ControlLabel>
                                <FormControl
                                  type="text"
                                  required
                                  name="name"
                                  onChange={(event) => {
                                    this.setState({ name: event.target.value });
                                    event.target.value === ""
                                      ? this.setState({
                                          nameError: (
                                            <small className="text-danger">
                                              Name is required.
                                            </small>
                                          ),
                                        })
                                      : this.setState({ nameError: null });
                                  }}
                                  value={this.state.name || ""}
                                  placeholder="Your  Name"
                                  style={{ width: "80%" }}
                                />
                                {this.state.nameError}
                              </FormGroup>
                              <div className="addlead-mobile-only">
                                <FormGroup>
                                  <ControlLabel>Email</ControlLabel>
                                  <FormControl
                                    type="email"
                                    name="email"
                                    onChange={(event) => {
                                      this.setState({
                                        email: event.target.value,
                                      });
                                      var emailRex =
                                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                                      emailRex.test(event.target.value) ===
                                      false
                                        ? this.setState({
                                            emailError: (
                                              <small className="text-danger">
                                                Email format should be{" "}
                                                <i>abc@doe.com</i>.
                                              </small>
                                            ),
                                          })
                                        : this.setState({ emailError: null });
                                    }}
                                    value={this.state.email || ""}
                                    placeholder="Your email "
                                    autoComplete="off"
                                    style={{ width: "80%" }}
                                  />
                                  {this.state.emailError}
                                </FormGroup>
                                <FormGroup>
                                  <ControlLabel>Mobile No</ControlLabel>
                                  <Col md={12} className="addlead-inline-phone">
                                    <Col
                                      md={2}
                                      sm={3}
                                      xs={3}
                                      className="no-padding"
                                      style={{ marginTop: "4px" }}
                                    >
                                      <select
                                        onChange={this.onChange}
                                        name="ccode"
                                        value={this.state.ccode}
                                        className="form-control"
                                      >
                                        <option value="+94">+94</option>
                                        <option value="+91">+91</option>
                                      </select>
                                    </Col>
                                    <Col md={10} sm={9} xs={8}>
                                      <FormControl
                                        type="number"
                                        required
                                        name="mobileno"
                                        onChange={(event) => {
                                          this.setState({
                                            mobileno: event.target.value,
                                          });
                                          event.target.value.length < 9 ||
                                          event.target.value.length > 11
                                            ? this.setState({
                                                mobilenoError: (
                                                  <small className="text-danger">
                                                    Please enter mobile nunber
                                                    from 9 to 11 digit.
                                                  </small>
                                                ),
                                              })
                                            : this.setState({
                                                mobilenoError: null,
                                              });
                                        }}
                                        value={this.state.mobileno || ""}
                                        placeholder="Your  Mobileno"
                                        style={{ width: "354px" }}
                                      />
                                    </Col>
                                    {this.state.mobilenoError}
                                  </Col>
                                </FormGroup>
                              </div>
                              <FormGroup>
                                <ControlLabel>Lead Status</ControlLabel>
                                <select
                                  name="leadstatus"
                                  value={this.state.leadstatus}
                                  onChange={(event) => {
                                    this.setState({
                                      leadstatus: event.target.value,
                                    });
                                    event.target.value === "0"
                                      ? this.setState({
                                          leadstatusError: (
                                            <small className="text-danger">
                                              Lead Status is required.
                                            </small>
                                          ),
                                        })
                                      : this.setState({
                                          leadstatusError: null,
                                        });
                                  }}
                                  className="form-control"
                                  style={{
                                    width: "80%",
                                    position: "relative",
                                    left: "4px",
                                  }}
                                >
                                  <option value="0" disabled>
                                    Select Lead Status
                                  </option>
                                  <option value="1" disabled>
                                    New
                                  </option>
                                  <option value="2" disabled>
                                    Negotiation
                                  </option>
                                  <option value="3">Subscribed</option>
                                  <option value="4" disabled>
                                    Lost
                                  </option>
                                </select>
                                {this.state.leadstatusError}
                              </FormGroup>
                              <FormGroup
                                className="addlead-formgroup-narrow"
                                style={{ width: "80%", marginLeft: "5px" }}
                              >
                                <ControlLabel>Select Company</ControlLabel>
                                <Select
                                  name="organization"
                                  value={this.state.organization}
                                  placeholder="Select Company"
                                  onChange={(value) =>
                                    this.onParentOrganizationChangeb2c(value)
                                  }
                                  options={this.state.organizationdetail}
                                />
                              </FormGroup>
                            </>
                          ) : (
                            " "
                          )}
                          {this.state.leadstatus == 3 ? (
                            <FormGroup>
                              <ControlLabel style={{ position: "absolute" }}>
                                Source
                              </ControlLabel>
                              <br />
                              <div className="order_source_data">
                                <Radio
                                  // style={{'display':'inline-block'}}
                                  number="5"
                                  option="1"
                                  name="source"
                                  onChange={this.onChange}
                                  checked={this.state.source === "1"}
                                  label="Flash"
                                />
                                <Radio
                                  // style={{'display':'inline-block'}}
                                  number="6"
                                  option="2"
                                  name="source"
                                  onChange={this.onChange}
                                  checked={this.state.source === "2"}
                                  label="oPharma"
                                />
                                <Radio
                                  // style={{'display':'inline-block'}}
                                  number="7"
                                  option="3"
                                  name="source"
                                  onChange={this.onChange}
                                  checked={this.state.source === "3"}
                                  label="MyPharma"
                                />
                                <Radio
                                  style={{ display: "inline-block" }}
                                  number="8"
                                  option="4"
                                  name="source"
                                  onChange={this.onChange}
                                  checked={this.state.source === "4"}
                                  label="Daraz"
                                />
                                <Radio
                                  style={{ display: "inline-block" }}
                                  number="9"
                                  option="5"
                                  name="source"
                                  onChange={this.onChange}
                                  checked={this.state.source === "5"}
                                  label="Kapuraka"
                                />
                                <Radio
                                  style={{ display: "inline-block" }}
                                  number="10"
                                  option="6"
                                  name="source"
                                  onChange={this.onChange}
                                  checked={this.state.source === "6"}
                                  label="E-channeling"
                                />
                              </div>
                            </FormGroup>
                          ) : (
                            ""
                          )}

                          <FormGroup>
                            <ControlLabel style={{ position: "absolute" }}>
                              Is B2B
                            </ControlLabel>
                            <br />
                            <div className="order_source_data addlead-b2b-inline">
                              <Radio
                                // style={{'display':'inline-block'}}
                                number="501"
                                option="1"
                                name="is_b2b"
                                onChange={this.onChange}
                                checked={this.state.is_b2b === "1"}
                                label="Yes"
                              />
                              &nbsp;
                              <Radio
                                // style={{'display':'inline-block'}}
                                number="601"
                                option="2"
                                name="is_b2b"
                                onChange={this.onChange}
                                checked={this.state.is_b2b === "2"}
                                label="No"
                              />
                            </div>
                          </FormGroup>
                        </Col>
                        <Col md={6} sm={6} xs={12}>
                          <FormGroup className="addlead-desktop-only">
                            <ControlLabel>Email</ControlLabel>
                            <FormControl
                              type="email"
                              name="email"
                              onChange={(event) => {
                                this.setState({ email: event.target.value });
                                var emailRex =
                                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                                emailRex.test(event.target.value) === false
                                  ? this.setState({
                                      emailError: (
                                        <small className="text-danger">
                                          Email format should be{" "}
                                          <i>abc@doe.com</i>.
                                        </small>
                                      ),
                                    })
                                  : this.setState({ emailError: null });
                              }}
                              value={this.state.email || ""}
                              placeholder="Your email "
                              autoComplete="off"
                              style={{ width: "80%" }}
                            />
                            {this.state.emailError}
                          </FormGroup>
                          <FormGroup className="addlead-desktop-only">
                            <ControlLabel>Mobile No</ControlLabel>
                            <Col md={12} className="addlead-inline-phone">
                              <Col
                                md={2}
                                sm={3}
                                xs={4}
                                className="no-padding"
                                style={{ marginTop: "4px" }}
                              >
                                <select
                                  onChange={this.onChange}
                                  name="ccode"
                                  value={this.state.ccode}
                                  className="form-control"
                                >
                                  <option value="+94">+94</option>
                                  <option value="+91">+91</option>
                                </select>
                              </Col>
                              <Col md={10} sm={9} xs={8}>
                                <FormControl
                                  type="number"
                                  required
                                  name="mobileno"
                                  onWheel={(e) => e.target.blur()}
                                  onChange={(event) => {
                                    this.setState({
                                      mobileno: event.target.value,
                                    });
                                    event.target.value.length < 9 ||
                                    event.target.value.length > 11
                                      ? this.setState({
                                          mobilenoError: (
                                            <small className="text-danger">
                                              Please enter mobile nunber from 9
                                              to 11 digit.
                                            </small>
                                          ),
                                        })
                                      : this.setState({ mobilenoError: null });
                                  }}
                                  value={this.state.mobileno || ""}
                                  placeholder="Your  Mobileno"
                                  style={{ width: "354px" }}
                                />
                              </Col>
                              {this.state.mobilenoError}
                            </Col>
                          </FormGroup>
                          <FormGroup>
                            <ControlLabel>Phone No</ControlLabel>
                            <Col md={12} className="addlead-inline-phone">
                              <Col
                                md={2}
                                sm={3}
                                xs={4}
                                className="no-padding"
                                style={{ marginTop: "4px" }}
                              >
                                <select
                                  onChange={this.onChange}
                                  name="pcode"
                                  value={this.state.pcode}
                                  className="form-control"
                                >
                                  <option value="+94">+94</option>
                                  <option value="+91">+91</option>
                                </select>
                              </Col>
                              <Col md={10} sm={9} xs={8}>
                                <FormControl
                                  type="number"
                                  required
                                  name="phone"
                                  onWheel={(e) => e.target.blur()}
                                  onChange={(event) => {
                                    this.setState({
                                      phone: event.target.value,
                                    });
                                    event.target.value.length < 9 ||
                                    event.target.value.length > 11
                                      ? this.setState({
                                          phoneError: (
                                            <small className="text-danger">
                                              Please enter phone nunber from 9
                                              to 11 digit.
                                            </small>
                                          ),
                                        })
                                      : this.setState({ phoneError: null });
                                  }}
                                  value={this.state.phone || ""}
                                  placeholder="Your  Phone No"
                                  style={{ width: "354px" }}
                                />
                              </Col>
                              {this.state.phoneError}
                            </Col>
                          </FormGroup>
                          <FormGroup>
                            <ControlLabel>Gender</ControlLabel>

                            <div className="order_source_data addlead-gender-inline">
                              <Radio
                                // style={{'display':'inline-block'}}
                                number="31"
                                option="male"
                                name="gender"
                                onChange={this.onChange}
                                checked={this.state.gender === "male"}
                                label="Male"
                              />
                              &nbsp;
                              <Radio
                                // style={{'display':'inline-block'}}
                                number="32"
                                option="female"
                                name="gender"
                                onChange={this.onChange}
                                checked={this.state.gender === "female"}
                                label="Female"
                              />
                              <Radio
                                // style={{'display':'inline-block'}}
                                number="11"
                                option="other"
                                name="gender"
                                onChange={this.onChange}
                                checked={this.state.gender === "other"}
                                label="Other"
                              />
                            </div>
                          </FormGroup>
                          <FormGroup>
                            <ControlLabel>Date Of Birth</ControlLabel>
                            <div
                              className="addlead-datetime"
                              style={{ width: "455px" }}
                            >
                              <Datetime
                                timeFormat={false}
                                dateFormat="YYYY-MM-DD"
                                inputProps={{ placeholder: "Date of Birth" }}
                                // defaultValue={new Date()}
                                closeOnSelect={true}
                                value={this.state.dob}
                                onChange={this.handleDateChange}
                              />
                            </div>
                          </FormGroup>
                          {/* ) : (
                        ""
                      )} */}
                        </Col>
                      </Row>
                    </div>
                    <div
                      className="order_middle_container"
                      style={{
                        position: "relative",
                        minHeight: "1px",
                        padding: "0 20px 20px 20px",
                      }}
                    ></div>
                    <div className="collapeablecomp_orderhistory">
                      <Collapsible
                        trigger="Diagnostic Details"
                        transitionTime={200}
                      >
                        {this.state.userrole == 6 ||this.state.userrole == 11 || 
                        this.state.userrole == 1 ||
                        this.state.userrole == 2 ? (
                          <h4 style={{ textAlign: "left", fontWeight: "bold" }}>
                            Diagnostic Details
                          </h4>
                        ) : (
                          ""
                        )}
                        <div
                          style={{
                            marginLeft: "10px",
                            marginRight: "10px",
                          }}
                        >
                          <Row>
                            <Col md={6} xs={12} sm={6}>
                              {this.state.userrole == 6 || this.state.userrole == 11 || 
                              this.state.userrole == 1 ||
                              this.state.userrole == 2 ? (
                                <>
                                  <FormGroup>
                                    <ControlLabel>NIC/Passport No</ControlLabel>
                                    <FormControl
                                      type="text"
                                      name="NIC_passportnum"
                                      placeholder="Enter NIC/Passport No"
                                      style={{ width: "455px" }}
                                      onChange={this.onChange}
                                      value={this.state.NIC_passportnum}
                                      min={1}
                                    ></FormControl>
                                  </FormGroup>

                                  <FormGroup>
                                    <ControlLabel>Occupation</ControlLabel>
                                    <FormControl
                                      type="text"
                                      name="occupation"
                                      value={this.state.occupation}
                                      placeholder="Enter Occupation"
                                      style={{ width: "455px" }}
                                      onChange={this.onChange}
                                    ></FormControl>
                                  </FormGroup>

                                  <FormGroup>
                                    <ControlLabel>MOH Area</ControlLabel>
                                    <FormControl
                                      type="text"
                                      name="MOHarea"
                                      value={this.state.MOHarea}
                                      placeholder="Enter MOH Area"
                                      style={{ width: "455px" }}
                                      onChange={this.onChange}
                                    ></FormControl>
                                  </FormGroup>

                                  <FormGroup>
                                    <ControlLabel>
                                      Emergency Contact Person name
                                    </ControlLabel>
                                    <FormControl
                                      type="text"
                                      name="emergency_contact_name"
                                      value={this.state.emergency_contact_name}
                                      placeholder="Enter Emergency Contact Person name"
                                      style={{ width: "455px" }}
                                      onChange={this.onChange}
                                    ></FormControl>
                                  </FormGroup>

                                  <FormGroup>
                                    <Checkbox
                                      number="15"
                                      checked={this.state.partial}
                                      onChange={this.checkpatient}
                                      label="Is this you ?"
                                    ></Checkbox>
                                  </FormGroup>
                                  {this.state.partial == true ? (
                                    <>
                                      <FormGroup>
                                        <ControlLabel>
                                          Patient name
                                        </ControlLabel>
                                        <FormControl
                                          type="text"
                                          name="partial_name"
                                          value={this.state.partial_name}
                                          placeholder="Enter Patient name"
                                          onChange={this.onChange}
                                        ></FormControl>
                                      </FormGroup>
                                      <FormGroup>
                                        <ControlLabel>
                                          Patient Phone no
                                        </ControlLabel>
                                        <Col md={12}>
                                          <Col
                                            md={2}
                                            className="no-padding"
                                            style={{ marginTop: "4px" }}
                                          >
                                            <select
                                              onChange={this.onChange}
                                              name="pccode"
                                              value={this.state.pccode}
                                              className="form-control"
                                            >
                                              <option value="+94">+94</option>
                                              <option value="+91">+91</option>
                                            </select>
                                          </Col>
                                          <Col md={10}>
                                            <FormControl
                                              type="number"
                                              name="partial_contact"
                                              value={this.state.partial_contact}
                                              placeholder="Enter Patient phone no"
                                              onChange={(event) => {
                                                this.setState({
                                                  partial_contact:
                                                    event.target.value,
                                                });
                                                event.target.value.length < 9 ||
                                                event.target.value.length > 11
                                                  ? this.setState({
                                                      partial_contactError: (
                                                        <small className="text-danger">
                                                          Please enter patient
                                                          phone no from 9 to 11
                                                          digit.
                                                        </small>
                                                      ),
                                                    })
                                                  : this.setState({
                                                      partial_contactError:
                                                        null,
                                                    });
                                              }}
                                            ></FormControl>
                                          </Col>
                                          {this.state.partial_contactError}
                                        </Col>
                                      </FormGroup>

                                      <FormGroup>
                                        <ControlLabel>
                                          Patient Email
                                        </ControlLabel>
                                        <FormControl
                                          type="email"
                                          name="partial_email"
                                          value={this.state.partial_email}
                                          placeholder="Enter Patient Email"
                                          onChange={(event) => {
                                            this.setState({
                                              partial_email: event.target.value,
                                            });
                                            var emailRex =
                                              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                                            emailRex.test(
                                              event.target.value,
                                            ) === false
                                              ? this.setState({
                                                  partial_emailError: (
                                                    <small className="text-danger">
                                                      Patient Email format
                                                      should be{" "}
                                                      <i>abc@doe.com</i>.
                                                    </small>
                                                  ),
                                                })
                                              : this.setState({
                                                  partial_emailError: null,
                                                });
                                          }}
                                        ></FormControl>
                                        {this.state.partial_emailError}
                                      </FormGroup>
                                    </>
                                  ) : (
                                    ""
                                  )}

                                  <FormGroup>
                                    <ControlLabel>Symptoms</ControlLabel>
                                    {/* {this.state.symptomsdata.map(s=>{

                              return <Checkbox  name="symptoms"  handlesymptoms={this.handlesymptoms} {...s} />
                            })} */}
                                    {this.state.symptomsdata.map((s, i) => (
                                      <Checkbox
                                        number={s.id}
                                        key={i}
                                        checked={s.checked}
                                        onChange={(e) =>
                                          this.handlesymptoms(e, i)
                                        }
                                        label={s.label}
                                      />
                                    ))}
                                  </FormGroup>
                                </>
                              ) : (
                                ""
                              )}
                            </Col>
                            <Col md={6} sm={6} xs={12}>
                              {this.state.userrole == 6 || this.state.userrole == 11 || 
                              this.state.userrole == 1 ||
                              this.state.userrole == 2 ? (
                                <>
                                  <FormGroup>
                                    <ControlLabel>
                                      Body Temperature
                                    </ControlLabel>
                                    <FormControl
                                      type="number"
                                      placeholder="Enter Body Temperature"
                                      style={{ width: "455px" }}
                                      onChange={this.onChange}
                                      name="bodytem"
                                      value={this.state.bodytem}
                                      min={1}
                                    ></FormControl>
                                  </FormGroup>

                                  <FormGroup>
                                    <ControlLabel>
                                      Emergency Contact Person Number
                                    </ControlLabel>
                                    <Col md={12}>
                                      <Col
                                        md={2}
                                        className="no-padding"
                                        style={{ marginTop: "4px" }}
                                      >
                                        <select
                                          onChange={this.onChange}
                                          name="eccode"
                                          value={this.state.eccode}
                                          className="form-control"
                                        >
                                          <option value="+94">+94</option>
                                          <option value="+91">+91</option>
                                        </select>
                                      </Col>
                                      <Col md={10}>
                                        <FormControl
                                          type="number"
                                          name="emergency_contact_num"
                                          value={
                                            this.state.emergency_contact_num
                                          }
                                          placeholder="Enter Emergency Contact Person Contact Number"
                                          style={{ width: "354px" }}
                                          onChange={(event) => {
                                            this.setState({
                                              emergency_contact_num:
                                                event.target.value,
                                            });
                                            event.target.value.length < 9 ||
                                            event.target.value.length > 11
                                              ? this.setState({
                                                  emergency_contact_numError: (
                                                    <small className="text-danger">
                                                      Please enter emergency
                                                      contact person number from
                                                      9 to 11 digit.
                                                    </small>
                                                  ),
                                                })
                                              : this.setState({
                                                  emergency_contact_numError:
                                                    null,
                                                });
                                          }}
                                        ></FormControl>
                                      </Col>
                                      {this.state.emergency_contact_numError}
                                    </Col>
                                  </FormGroup>

                                  <FormGroup>
                                    <ControlLabel>
                                      Epidemiological Evidence
                                    </ControlLabel>
                                    {this.state.Epidemiological_Evidence_data.map(
                                      (s, i) => (
                                        <Checkbox
                                          number={s.id}
                                          key={i}
                                          checked={s.checked}
                                          onChange={(e) =>
                                            this.handleEpidemiological_Evidence(
                                              e,
                                              i,
                                            )
                                          }
                                          label={s.label}
                                        />
                                      ),
                                    )}
                                  </FormGroup>
                                </>
                              ) : (
                                ""
                              )}
                            </Col>
                          </Row>
                        </div>
                      </Collapsible>
                    </div>

                    <div
                      className="order_middle_container"
                      style={{
                        position: "relative",
                        minHeight: "1px",
                        padding: "0 20px 20px 20px",
                      }}
                    ></div>
                    <div className="collapeablecomp_orderhistory">
                      <Collapsible
                        trigger="Address Details"
                        transitionTime={200}
                      >
                        <Row>
                          <Col sm={12} xs={12} md={12}>
                            {this.state.addresslist.map((x, i) => {
                              return (
                                <div>
                                  {/* <hr
                                style={{
                                  background: '#d9d9d9',
                                  color: '#d9d9d9',
                                  borderColor: '#d9d9d9',
                                  height: '2px',
                                  }}
                              /> */}
                                  <div
                                    style={{}}
                                    className="address_heading_b2c"
                                  >
                                    <a
                                      style={{ float: "right" }}
                                      href="javascript:void(0)"
                                      onClick={(e) => this.handleRemoveClick(i)}
                                    >
                                      X
                                    </a>
                                    <h4
                                      style={{
                                        textAlign: "left",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Address {x.srno}
                                    </h4>
                                    <div
                                      style={{
                                        marginLeft: "10px",
                                        marginRight: "10px",
                                      }}
                                    >
                                      <div
                                        className="col-Address" //style={{backgroundColor:"#D3D3D3"}}
                                      >
                                        <Row>
                                          {/* <Col
                                  md={6}
                                  xs={12}
                                  sm={6}
                                  style={{
                                    marginBottom: "70px",
                                  }}
                                >
                                  <div style={{ marginBottom: "20px" }}>
                                    <Autocomplete
                                      apiKey={
                                        "AIzaSyDYcP1T9HnFmllB0f_lMixg9EwNdkYCenE"
                                      }
                                      options={{
                                        types: "(cities)",
                                        componentRestrictions: {
                                          country: "LK",
                                        },
                                      }}
                                      style={{
                                        width: "92%",
                                        padding: "8px 12px",
                                      }}
                                      onPlaceSelected={(place) =>
                                        this.handlePlaceSelected(place, i)
                                      }
                                    />
                                    <FormGroup>
                                      <ControlLabel>
                                        Enter a location
                                      </ControlLabel>
                                      <FormControl
                                        name="coordinates"
                                        type="text"
                                        placeholder="Enter your location"
                                        // value={x.customaddress}
                                        onChange={(e) =>
                                          this.handleInputLocationChange(e, i)
                                        }
                                      />
                                      {x.customaddressError}
                                    </FormGroup>
                                  </div>
                                  <div style={{ height: "380px" }}>
                                  <Map
                                      google={this.props.google}
                                      zoom={14}
                                      initialCenter={{
                                        lat: '6.895686610681836',
                                        lng: '79.88250590602851',
                                      }}
                                      onReady={this.onMapReady}
                                      style={{ width: "90%" }}
                                      center={{
                                        lat: lat || x.latitude || "6.9271",
                                        lng: lng || x.longitude || "79.8612",
                                      }}
                                    >
                                      <Marker
                                        // name={this.state.selectedPlace.name}
                                        position={{
                                          lat: lat || x.latitude || "6.9271",
                                          lng: lng || x.longitude || "79.8612",
                                        }}
                                      />
                                    </Map>
                                  <GoogleMap
                                      defaultZoom={8}
                                      defaultCenter={{
                                        lat: "6.895050683824454",
                                        lng: "79.89280524763893",
                                      }}
                                    >
                                      <Marker
                                        position={{
                                          lat: "6.895050683824454",
                                          lng: "79.89280524763893",
                                        }}
                                      />
                                    </GoogleMap>
                                  <GoogleMap
                                      center={{
                                        lat: lat || x.latitude || "6.9271",
                                        lng: lng || x.longitude || "79.8612",
                                      }}
                                      google={this.props.google}
                                      zoom={14}
                                      initialCenter={{
                                        lat: lat || x.latitude || "6.9271",
                                        lng: lng || x.longitude || "79.8612",
                                      }}
                                      onReady={this.onMapReady}
                                      style={{ width: "90%" }}
                                    >
                                      <Marker
                                        position={{ lat: lat, lng: lng }}
                                      />
                                    </GoogleMap>
                                  <div>
                                      <iframe
                                        width="100%"
                                        height="600"
                                        src={googleURL}
                                        frameborder="0"
                                        scrolling="no"
                                        marginheight="0"
                                        marginwidth="0"
                                      ></iframe>
                                      <br />
                                    </div>
                                  </div>
                                </Col> */}
                                          <Col style={{ marginRight: "10px" }}>
                                            <Row style={{ marginLeft: "20px" }}>
                                              <Col md={6} xs={12} sm={6}>
                                                <FormGroup>
                                                  <ControlLabel>
                                                    Address Line 1
                                                  </ControlLabel>
                                                  <FormControl
                                                    name="address_line_1"
                                                    value={x.address_line_1}
                                                    onChange={(e) =>
                                                      this.handleInputChange(
                                                        e,
                                                        i,
                                                      )
                                                    }
                                                    placeholder="Enter Address Line 1"
                                                    type="text"
                                                    // disabled
                                                  />
                                                  {
                                                    this.state
                                                      .address_line_1Error
                                                  }
                                                </FormGroup>
                                              </Col>
                                              <Col md={6} xs={12} sm={6}>
                                                <FormGroup>
                                                  <ControlLabel>
                                                    Address Line 2
                                                  </ControlLabel>
                                                  <FormControl
                                                    name="address_line_2"
                                                    value={x.address_line_2}
                                                    onChange={(e) =>
                                                      this.handleInputChange(
                                                        e,
                                                        i,
                                                      )
                                                    }
                                                    placeholder="Enter Address Line 2"
                                                    type="text"
                                                    // disabled
                                                  />
                                                  {
                                                    this.state
                                                      .address_line_2Error
                                                  }
                                                </FormGroup>
                                              </Col>
                                              <Col md={6} xs={12} sm={6}>
                                                <FormGroup>
                                                  <ControlLabel>
                                                    Enter the location
                                                    coordinates
                                                  </ControlLabel>
                                                  <FormControl
                                                    name="coordinates"
                                                    type="text"
                                                    placeholder="Enter your location"
                                                    // value={
                                                    //   this.state.coordinates || ""
                                                    // }
                                                    onChange={(e) =>
                                                      this.handleInputLocationChange(
                                                        e,
                                                        i,
                                                      )
                                                    }
                                                  />
                                                  {/* {x.customaddressError} */}
                                                </FormGroup>
                                              </Col>
                                            </Row>
                                          </Col>
                                          <Col style={{ marginRight: "10px" }}>
                                            <Row style={{ marginLeft: "20px" }}>
                                              <h5
                                                style={{
                                                  textAlign: "left",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                Add more details
                                              </h5>
                                              <Col
                                                md={6}
                                                xs={12}
                                                sm={6}
                                                style={{ marginBottom: "10px" }}
                                              >
                                                <ControlLabel>
                                                  Address type
                                                </ControlLabel>
                                                <br></br>
                                                <select
                                                  className="form-control"
                                                  name="addresstype"
                                                  onChange={(e) =>
                                                    this.handleInputChange(e, i)
                                                  }
                                                  value={x.addresstype}
                                                >
                                                  <option value="">
                                                    Select address type
                                                  </option>
                                                  <option value="Home">
                                                    Home
                                                  </option>
                                                  <option value="Office">
                                                    Office
                                                  </option>
                                                  <option value="Custom">
                                                    Custom
                                                  </option>
                                                </select>
                                                {x.addresstypeError}
                                              </Col>
                                              <Col md={6} xs={12} sm={6}>
                                                {x.addresstype == "Custom" && (
                                                  <FormGroup>
                                                    <ControlLabel>
                                                      Custom Address Field
                                                    </ControlLabel>
                                                    <FormControl
                                                      name="customaddress"
                                                      type="text"
                                                      placeholder="Enter Custom Address Field"
                                                      value={x.customaddress}
                                                      onChange={(e) =>
                                                        this.handleInputChange(
                                                          e,
                                                          i,
                                                        )
                                                      }
                                                    />
                                                    {x.customaddressError}
                                                  </FormGroup>
                                                )}
                                              </Col>
                                              {/* <Col md={6} xs={12} sm={6}>
                                      <FormGroup>
                                        <ControlLabel>
                                          Office number/ Apartment/ House number{" "}
                                        </ControlLabel>
                                        <FormControl
                                          name="address_line_2"
                                          value={x.address_line_2}
                                          onChange={(e) =>
                                            this.handleInputChange(e, i)
                                          }
                                          placeholder="E.g: 1/2 3rd Floor"
                                          type="text"
                                        />
                                      </FormGroup>
                                    </Col> */}
                                              <Col md={6} xs={12} sm={6}>
                                                <FormGroup>
                                                  <ControlLabel>
                                                    Country
                                                  </ControlLabel>
                                                  <select
                                                    name="country"
                                                    onChange={(e) =>
                                                      this.handleInputChange(
                                                        e,
                                                        i,
                                                        true,
                                                      )
                                                    }
                                                    value={x.country}
                                                    className="form-control"
                                                  >
                                                    <option value="0">
                                                      Select Country
                                                    </option>
                                                    {country.map((country) => (
                                                      <option
                                                        value={country.id}
                                                      >
                                                        {country.country_name}
                                                      </option>
                                                    ))}
                                                  </select>
                                                  {x.country_error}

                                                  {this.state.countryError}
                                                </FormGroup>
                                              </Col>
                                              <Col md={6} xs={12} sm={6}>
                                                <FormGroup>
                                                  <ControlLabel>
                                                    District
                                                  </ControlLabel>
                                                  <select
                                                    className="form-control"
                                                    name="city"
                                                    value={x.city}
                                                    onChange={(e) =>
                                                      this.handleInputChange(
                                                        e,
                                                        i,
                                                      )
                                                    }
                                                    placeholder="Enter City"
                                                  >
                                                    <option value="0">
                                                      {" "}
                                                      Select District
                                                    </option>
                                                    {this.state.city_info.map(
                                                      (city) => (
                                                        <option value={city.id}>
                                                          {city.city_name}
                                                        </option>
                                                      ),
                                                    )}
                                                  </select>
                                                  {x.city_error}
                                                </FormGroup>
                                              </Col>
                                              {/* <Col md={6} xs={12} sm={6}>
                                      <FormGroup>
                                        <ControlLabel>State</ControlLabel>
                                        <FormControl
                                          name="state"
                                          value={x.state}
                                          onChange={(e) =>
                                            this.handleInputChange(e, i)
                                          }
                                          placeholder="Enter State"
                                          type="text"
                                        />
                                      </FormGroup>
                                    </Col>
                                    <Col md={6} xs={12} sm={6}>
                                      <FormGroup>
                                        <ControlLabel>Postal Code</ControlLabel>
                                        <FormControl
                                          name="postalcode"
                                          value={x.postalcode}
                                          onChange={(e) =>
                                            this.handleInputChange(e, i)
                                          }
                                          placeholder="Enter Postal Code"
                                          type="number"
                                        />
                                      </FormGroup>
                                    </Col> */}
                                            </Row>
                                            {/* <Row></Row> */}
                                          </Col>
                                        </Row>
                                      </div>
                                    </div>
                                  </div>
                                  <br></br>
                                </div>
                              );
                            })}

                            <FormGroup>
                              <Button
                                class="btn-color" //bsStyle="info"
                                fill
                                onClick={this.handleAddClick}
                              >
                                Add Another Address{" "}
                                <i className="fa fa-plus"></i>
                              </Button>
                            </FormGroup>
                          </Col>
                        </Row>
                      </Collapsible>
                    </div>

                    <FormGroup>
                      <ControlLabel>Comment</ControlLabel>
                      <textarea
                        name="comment"
                        value={this.state.comment}
                        className="form-control"
                        onChange={(event) => {
                          this.setState({ comment: event.target.value });
                        }}
                        rows="3"
                        placeholder="Enter Comment"
                        type="textarea"
                      ></textarea>
                    </FormGroup>

                    <Button
                      disabled={!this.state.processing}
                      onClick={this.onSubmit}
                      class="btn-color" // bsStyle="info"
                      fill
                    >
                      Submit
                    </Button>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

// export default addlead;
export default GoogleApiWrapper({
  apiKey: "AIzaSyDYcP1T9HnFmllB0f_lMixg9EwNdkYCenE",
})(addlead);
